import * as actionTypes from 'constants/action-types';
import { action } from 'typesafe-actions';
import { ActionCreator, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { ApplicationState } from '../../rootReducer';
import { DevOptions, loadDevOptions, saveDevOptions } from '../../../utils/localStorageUtil';
import _ from 'lodash';

export type ToggleStartMockingPanelAction = {
  type: typeof actionTypes.TOGGLE_START_MOCKING_BANNER;
};

export type UpdateStartMockingPanelAction = {
  type: typeof actionTypes.UPDATE_START_MOCKING_BANNER;
  payload: boolean;
};

export const toggleStartMockingPanel = () => action(actionTypes.TOGGLE_START_MOCKING_BANNER);

export const updateStartMockingPanel = (show: boolean) => action(actionTypes.UPDATE_START_MOCKING_BANNER, show);

export const toggleStartMockingPanelThunk: ActionCreator<any> = (): ThunkAction<any, ApplicationState, null, any> => {
  return async (dispatch: ThunkDispatch<ApplicationState, any, AnyAction>) => {
    let devOptions: DevOptions | undefined = loadDevOptions();

    if (_.isNil(devOptions)) {
      devOptions = {
        hideStartMockingBanner: true,
        devMode: false,
        disableStatusPage: false,
        silentErrors: false,
        stickyToasts: false,
        enableLocationChange: false,
      };
    }

    saveDevOptions(devOptions);
    dispatch(toggleStartMockingPanel());
  };
};
